import LinkButton from '@standardsdigital/ui-components/LinkButton';
import { useTranslation } from 'react-i18next';
import { useGetBffUserQuery } from 'redux/services/bffUserApi';
import styles from './AccessDeniedPage.module.css';

function AccessDeniedPage() {
  const { t } = useTranslation();

  const { data: claims } = useGetBffUserQuery();
  const logOutUrl = claims?.find((claim) => claim.type === 'bff:logout_url')?.value;

  const title = `${String(t('authentication.unauthorizedTitle'))} | ${t(
    'headings.subscriptionManagement',
  )}`;

  return (
    <>
      <title>{title}</title>
      <section className={styles.pageWrapper}>
        <h1 className="sd-heading-lg">{t('authentication.unauthorizedTitle')}</h1>
        <p className={styles.message}>{t('authentication.unauthorizedMessage')}</p>
        <LinkButton href={logOutUrl} variant="primary">
          {t('authentication.logOut')}
        </LinkButton>
      </section>
    </>
  );
}

export default AccessDeniedPage;
